<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import request from '@/services/request';

import ModalFormComponent from '@/components/vacations/ModalFormComponent.vue';
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
	name: "vacations-table",
	components: {
		ModalFormComponent,
		DatePicker
	},
	data() {
		return {
			loadAll: false,
			vacations: {},
			name: '',
			editVacation: true,
			search: {
				search: '',
				date: '',
				company_id: '',
				user_id: '',
				type_id: '',
				status: 0,
			},
			idConvert: '',
			idUser: '',
			page: 1,
			send: false,
			catalogue: new Catalogue(),
			load: false,
		}
	},
	async mounted() {
		this.loadAll = true;

		this.list();
		if(this.authUser.organization_charts_id != 1){ 
            this.catalogue.get_users_juniors(this.authUser.id);
        }else{
			this.catalogue.get_users_employees();
		}

		if(this.authUser.organization_charts_id == 10 || this.authUser.organization_charts_id == 15){ 
            this.catalogue.get_companies_users(this.authUser.id);
        }else{
            this.catalogue.get_company_pays();
        }

		this.setHeaderTitle('Solicitudes de Vacaciones');
		this.loadAll = false;

	},
	created() {
		Event.$on("event-load-vacations", () => {
			this.list();
		});
	},
	methods: {
		approve(vacation) {
			let tit = 'Aprobar Vacaciones';
			let txt = 'Seguro que quiere aprobar la solicitud';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then(async (result) => {
				if (result.isConfirmed) {
					let _endpoint = '/vacations_approve';
					let form = {
						id: vacation.id
					};
					try {
						let response = await request.post(_endpoint, form).then(function (response) { return response; });
						Event.$emit('event-load-vacations');
						this.successNotification(response.data.message);
					} catch (error) {
						this.errors = await this.errorNotification(error)
					}
				}
			});

		},
		reject(vacation) {
			let tit = 'Rechazar Vacaciones';
			let txt = 'Seguro que quiere rechazar la solicitud';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then(async (result) => {
				if (result.isConfirmed) {
					let _endpoint = '/vacations_reject';
					let form = {
						id: vacation.id
					};
					try {
						let response = await request.post(_endpoint, form).then(function (response) { return response; });
						Event.$emit('event-load-vacations');
						this.successNotification(response.data.message);
					} catch (error) {
						this.errors = await this.errorNotification(error)
					}
				}
			});

		},
		// cancelBill(id) {
		// 	let vm = this;
		// 	// console.log(id);
		// 	this.$swal({
		// 		title: 'Motivos de Cancelación',
		// 		input: 'text',
		// 		icon: 'warning',
		// 		inputAttributes: {
		// 			autocapitalize: 'off'
		// 		},
		// 		showCancelButton: true,
		// 		confirmButtonText: 'Guardar',
		// 		showLoaderOnConfirm: true,
		// 		preConfirm: async (message) => {
		// 			// console.log(message);
		// 			let form = {
		// 				id: id,
		// 				message: message,
		// 			};
		// 			let _endpoint = '/cancel_vacation';
		// 			try {
		// 				let { data } = await request.postMedia(_endpoint, form)
		// 				if (data) {
		// 					// console.log(data);
		// 					await vm.successNotification(data.message);
		// 					await vm.list();
		// 				}
		// 			} catch (error) {
		// 				vm.errors = {};
		// 				if (error.response) {
		// 					vm.errors = vm.errorNotification(error);
		// 				}
		// 			}
		// 		},
		// 		allowOutsideClick: () => !this.$swal.isLoading()
		// 	}).then((result) => {
		// 		if (result.isConfirmed) {
		// 			// console.log(result);
		// 		}
		// 	})

		// },
		deleted: function (id) {
			let tit = 'Eliminar Vacaciones';
			let txt = 'Seguro que quiere eliminar la solicitud';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then((result) => {
				if (result.isConfirmed) {
					this.callDeleted(id);
				}
			});
		},
		async callDeleted(id) {
			let _endpoint = '/vacations/' + id;
			try {
				let response = await request.destroy(_endpoint).then(function (response) { return response; });
				this.list();
				this.successNotification(response.data.message);
			} catch (error) {
				this.errors = await this.errorNotification(error)
			}
		},
		async newVacation(account = {}, edit = true) {
			this.editVacation = edit;
			Event.$emit('event-show-addVacation', account);
		},
		async list(page = 1) {
			this.load = true;
			let service = request;
			let search = this.search;
			let _endpoint = '/vacations';
			search.search = this.name;
			try {
				let { data } = await service.list(_endpoint, page, search)
				if (data) {
					// console.log(data);
					this.vacations = data;
					this.load = false;

				}
			} catch (error) {
				// console.log(error);
				this.load = false;

			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			resetPassword: 'auth/resetPass',
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	},
	watch: {
		'search': {
			handler: function () {
				this.list();
			},
			deep: true
		}
	},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		})
	},
}
</script>

<template>
	<div class="col-12">
		<div class="card card-outline card-navy">
			<div class="card-header">
				<h3 class="card-title">Lista de Solicitudes de Vacaciones</h3>
				<div class="card-tools">
					<button @click="newVacation()" v-if="this.authUser.user_id" class="btn btn-sm btn-outline-info">
						<i class="fa fa-plus"></i> Solicitud
					</button>

				</div>
			</div>
			<div class="card-body">
				<div class="row">

					<div class="col-md-6">
						<label>Rango de fechas :</label>
						<date-picker format="YYYY-MM-DD" valueType="format" :range="true"
							v-model="search.date"></date-picker>
					</div>
					<div class="col-md-6">
						<label>Empresa :</label>

						<select v-model="search.company_id" class="form-control" v-if="authUser.organization_charts_id != 10 && authUser.organization_charts_id != 15">
							<option value=""> Sin empresa </option>
							<option v-for="(company, index) in catalogue.company_pays" :value="company.id" :key="index">
								{{ company.name }}</option>
						</select>

						<select v-model="search.company_id" class="form-control" v-else>
                            <option value=""> Sin empresa </option>
                            <option v-for="(company, index) in catalogue.companies_users" :value="company.id" :key="index">
                                {{ company.name }}
							</option>
                        </select>
					</div>

				</div>
				<br>
				<div class="row">
					<div class="col-md-6">
						<label>Usuario :</label>

						<select v-model="search.user_id" class="form-control" v-if="authUser.organization_charts_id != 1">
							<option value=""> Sin usuario </option>
							<option v-for="(user, index) in catalogue.users_juniors" :value="user.id" :key="index">
								{{ user.name }} {{ user.last_name }}
							</option>
						</select>

						<select v-model="search.user_id" class="form-control" v-else>
                            <option value=""> Sin usuario </option>
							<option v-for="(user, index) in catalogue.users_employees" :value="user.id" :key="index">
								{{ user.name }} {{ user.last_name }}
							</option>
                        </select>
					</div>
					<div class="col-md-6">
						<label>Tipo :</label>

						<select v-model="search.type_id" class="form-control">
							<option value="P"> Pagadas </option>
							<option value="N"> No Pagadas </option>
						</select>
					</div>
				</div>
				<br>
				<div class="row">
					<div class="col-md-12">
						<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
							<li class="nav-item">
								<a class="nav-link active" @click="search.status = 0" data-toggle="pill" role="tab"
									aria-selected="true">Pendientes</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click="search.status = 1" data-toggle="pill" role="tab"
									aria-selected="false">Aprobadas</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click="search.status = 2" data-toggle="pill" role="tab"
									aria-selected="false">Rechazadas</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="table-responsive">
					<table class="table table-bordered text-center text-sm">
						<thead>
							<tr>
								<th>ID</th>
								<th>Empleado</th>
								<th>Días Pedidos</th>
								<th>Periodo</th>
								<th>Tipo</th>
								<th>Opciones</th>
							</tr>
						</thead>
						<tbody v-if="load">
							<tr>
								<td align="center" colspan="8">
									<i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
									<h5>Cargando</h5>

								</td>
							</tr>
						</tbody>
						<tbody v-else-if="vacations.total > 0">
							<tr v-for="(vacation, index) in vacations.data" :key="index">
								<td>
									{{ vacation.id }}
								</td>

								<td>{{ vacation.user.name }} {{ vacation.user.last_name }}</td>
								<td>{{ vacation.number}}</td>
								<td>{{ vacation.date_start | toDateTime }} - {{ vacation.date_end | toDateTime }}</td>
								<td>
									<span v-if="vacation.type=='P'">
										PAGADAS
									</span>
									<span v-else>
										NO PAGADAS
									</span>
								</td>
								<td>
									<button @click="approve(vacation)" v-if="vacation.user.senior.id==authUser.id && vacation.status!=1"
										class="btn m-1 btn-outline-success btn-sm">
										<i class="fas fa-check "> </i> Aprobar
									</button>

									<button @click="reject(vacation)"
										class="btn m-1 btn-outline-warning btn-sm"
										v-if="vacation.user.senior.id==authUser.id && vacation.status!=2">
										<i class="fas fa-check "> </i> Rechazar
									</button>

									<button @click="newVacation(vacation, true)"
										class="btn m-1 btn-outline-primary btn-sm"
										v-if="authUser.id==vacation.user_id">
										<i class="fas fa-edit "> </i> Editar
									</button>
									<button @click="newVacation(vacation, false)"
										class="btn m-1 btn-outline-secondary btn-sm">
										<i class="fas fa-eye "> </i> Ver más
									</button>

									<button type="button" @click="deleted(vacation.id)"
										class="btn m-1 btn-outline-danger btn btn-sm "
										v-if="(vacation.user.senior.id==authUser.id || vacation.user.id==authUser.id ) && vacation.status==0">
										<i class="fa fa-trash"></i> Eliminar
									</button>
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="9">Sin resultados.</td>
							</tr>
						</tbody>
					</table>
					<pagination v-model="page" :records="parseInt(vacations.total)" :per-page="parseInt(vacations.per_page)"
						@paginate="list" />
				</div>
			</div>
		</div>
		<ModalFormComponent :prop_edit="editVacation" />
	</div>
</template>

<style scoped>
.pagination {
	margin-bottom: 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
	{
	opacity: 0;
}
</style>
